<div class="orientacoes-colunas">
  <div class="orientacoes-corpo">
    <div class="orientacoes-intro">
      <h2 class="orientacoes-intro-titulo">Antes de fazer seu pedido de informação</h2>

      <p class="orientacoes-intro-texto">
        Reserve um minuto para ler as orientações legais e operacionais sobre a Lei de Acesso à
        Informação. Isso garante uma análise mais ágil e uma resposta precisa por parte do SIC.
      </p>
    </div>

    <div class="orientacoes-lista">
      @for (orientacao of orientacoes; track orientacao.id) {
        <section class="orientacoes-secao" [attr.data-aberta]="orientacaoAberta() === orientacao.id">
          <h3 class="orientacoes-secao-cabecalho">
            <button
              type="button"
              class="orientacoes-secao-botao"
              [attr.aria-expanded]="orientacaoAberta() === orientacao.id"
              [attr.aria-controls]="'sic-painel-' + orientacao.id"
              (click)="alternarOrientacao(orientacao.id)"
            >
              <span class="orientacoes-secao-titulo">
                <i-lucide [name]="orientacao.icone" size="16" aria-hidden="true"></i-lucide>
                {{ orientacao.titulo }}
              </span>

              <i-lucide
                class="orientacoes-secao-seta"
                [name]="orientacaoAberta() === orientacao.id ? 'chevron-up' : 'chevron-down'"
                size="18"
                aria-hidden="true"
              ></i-lucide>
            </button>
          </h3>

          @if (orientacaoAberta() === orientacao.id) {
            <div class="orientacoes-secao-painel" [id]="'sic-painel-' + orientacao.id">
              <p class="orientacoes-secao-texto">{{ orientacao.conteudo }}</p>
            </div>
          }
        </section>
      }
    </div>

    <label class="orientacoes-aceite" [attr.data-pendente]="aceiteDestacado()">
      <input
        class="orientacoes-aceite-campo"
        type="checkbox"
        [checked]="store.orientacoesAceitas()"
        [attr.aria-describedby]="aceiteDestacado() ? 'orientacoes-aceite-erro' : null"
        (change)="alternarAceite($event)"
      />
      <span>Li e compreendi as orientações legais para preenchimento da solicitação.</span>
    </label>

    @if (aceiteDestacado() && !store.orientacoesAceitas()) {
      <p class="orientacoes-aceite-erro" id="orientacoes-aceite-erro" role="alert">
        <i-lucide name="circle-alert" size="16" aria-hidden="true"></i-lucide>
        Marque o aceite das orientações para escolher como deseja abrir o pedido.
      </p>
    }

    @for (erro of errosServidor(); track erro) {
      <p class="orientacoes-aceite-erro" role="alert">
        <i-lucide name="circle-alert" size="16" aria-hidden="true"></i-lucide>
        {{ erro }}
      </p>
    }
  </div>

  <app-cartao-acesso-sic
    [sessaoIniciada]="store.sessaoIniciada()"
    [anonimo]="store.anonimo()"
    [focarLogin]="focarLogin()"
    [bloqueado]="!store.orientacoesAceitas()"
    mensagemBloqueio="Marque o aceite das orientações para continuar."
    (continuar)="continuar.emit()"
    (autenticado)="autenticado.emit()"
    (acessarGov)="acessarGov.emit()"
    (seguirAnonimo)="seguirAnonimo.emit()"
    (saiu)="saiu.emit()"
    (bloqueioAcionado)="destacarAceite()"
  ></app-cartao-acesso-sic>
</div>
